import React, { useState, useEffect } from 'react';
import { Route, Switch } from "react-router-dom";
import '../common/css/global.css';
import './App.css';
import * as project from "../common/api/projects";
import * as impact from '../common/api/impact';
import ImpactPage from "./pages/ImpactPage";
import merchantLogo from './media/MAG_STN_FLAT_REV_RGB.png';
import MagEmaStnLandingPage from "../airport-mag/pages/MagEmaStnLandingPage";

function App() {
  const merchantCode = 'AIRPORT_STN';
  const [fetchedImpact, setFetchedImpact] = useState();

  const quoteData = {
    name: 'Steve Griffiths',
    position: 'Managing Director, London Stansted Airport',
    text: 'Our Climate Friendly Traveller tool, powered by CarbonClick, makes offsetting easy for passengers and means they can make a real difference both for the environment and a number of great causes every time they fly through London Stansted Airport'
  };

  useEffect(() => {
    impact.merchants(merchantCode, "en_GB", ['flightsImpact'] )
      .then(response => response.json())
      .then(body => {
        setFetchedImpact(body)
      })
      .catch(setFetchedImpact);
  }, []);

  return (
    <>

      <Switch>
        {/* DO NOT DELETE IMPACT - The impact page should always be kept, even if not specified in a design */}
        <Route
          exact
          path={`/impact`}
          key="app-mag-impact"
        >
          <ImpactPage merchantCode={merchantCode} />
        </Route>
        {/* DO NOT DELETE IMPACT - The impact page should always be kept, even if not specified in a design */}
        <Route
          path={`/`}
          key="app-mag-landing"
        >
          <MagEmaStnLandingPage merchantLogo={merchantLogo} fetchedImpact={fetchedImpact} merchantCode={merchantCode} quoteData={quoteData}/>
        </Route>
      </Switch>
    </>
  );
}

export default App;
